export default "__VITE_ASSET__Cc6V$YI9__"